import React from "react";
import { NavLink } from 'react-router-dom'
import { CCard, CCardHeader, CCardBody, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CListGroup, CListGroupItem } from '@coreui/react'
import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { codeSnippet } from '../../utils/codeSnippet/db/db';


function CockroachDB () {
const tableStyle = {
  width: "80%",
  margin: "20px auto",
  borderCollapse: "collapse",
  background: "#ffffff",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  fontFamily: "Arial, sans-serif"
};

const thStyle = {
  border: "1px solid #ddd",
  padding: "12px",
  backgroundColor: "#2c3e50",
  color: "#ffffff",
  textAlign: "left"
};

const tdStyle = {
  border: "1px solid #ddd",
  padding: "12px",
  textAlign: "left"
};

const rowAltStyle = {
  backgroundColor: "#f2f2f2"
};

const captionStyle = {
  fontSize: "20px",
  fontWeight: "bold",
  marginBottom: "10px"
};

const data = [
  { id: 1, customer_id: 1, amount: 100 },
  { id: 2, customer_id: 1, amount: 200 },
  { id: 3, customer_id: 2, amount: 300 }
];
const data2 = [
  { name: 'John', amount: 100 },
  { name: 'John', amount: 200 },
  { name: 'Alice', amount: 300 }
];
const data3 = [
  { name: 'John', amount: 100 },
  { name: 'John', amount: 200 },
  { name: 'Alice', amount: 300 },
  { name: 'Bob', amount: null }
];
  const data4 = [
    { name: "John", amount: 100 },
    { name: "John", amount: 200 },
    { name: "Alice", amount: 300 },
  ];
  return (
    <CCard className="mb-4">
      <CCardHeader><strong>Dashboard</strong></CCardHeader>
			<CCardBody>
				<CAccordion flush>
				<CAccordionItem itemKey={1}>
						<CAccordionHeader>CockroachDB</CAccordionHeader>
						<CAccordionBody>   	
							<p>CockroachDB is a distributed SQL database designed for high availability, scalability, and resilience.</p>

							<p>It runs across multiple servers or data centers and automatically replicates and distributes data, ensuring strong fault tolerance.</p>
							<p>Key Characteristics:</p>
							<ol>
								<li><p>Distributed, multi-node architecture</p></li>
								<li><p>Horizontal scalability (easily add more nodes)</p></li>
								<li><p>Automatic failover</p></li>
								<li><p>Self-healing capabilities</p></li>
							</ol>
							<p><b>Database</b></p>
							<p>A database is a logical container for schemas, tables, and other objects.In CockroachDB, you can create multiple databases within a single cluster.</p>
							<p><b>Schema</b></p>
							<p>A schema is a namespace within a database that organizes tables and other objects. CockroachDB supports multiple schemas per database.</p>
							<p>A schema is a logical container for database objects like tables, views, and procedures.</p>

							<p><b>Performance</b></p>
							<ol>
								<li><p>Primary Key Design</p>
								<p>Choosing an appropriate primary key is crucial for performance in CockroachDB. A well-designed primary key can help distribute data evenly across nodes and improve query performance.</p>
								<p>Problem with sequential keys (AUTO_INCREMENT / SERIAL): All new writes go to the same range/node</p>
								<p>Use UUID (v4) or hashed keys or Use composite keys to spread data</p>
								</li>
								<li><p>Table Partitioning (Data Locality)</p>
								<p>When to use partitioning:Large tables (millions+ rows), Geo-distributed apps, Multi-tenant systems</p>
								<p>ex: Partition by region, Partition by tenant_id, Partition by date</p></li>

							</ol>
					</CAccordionBody>
				</CAccordionItem>
				<CAccordionItem itemKey={2}>
						<CAccordionHeader>PL/SQL</CAccordionHeader>
						<CAccordionBody>  
							<p>PL/SQL (Procedural Language/SQL) is an extension of SQL used in Oracle Database that lets you write procedural logic inside the database.</p> 	
							<p>Use PL/SQL when:</p>
							<ol>
								<li><p>Heavy data processing is inside DB</p></li>
								<li><p>Reduce network calls</p></li>
								<li><p>Complex transactions</p></li>
								<li><p>Batch jobs</p></li>
							</ol>
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code1}</SyntaxHighlighter>
							<p><b>Spring boot Example</b></p>
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code2}</SyntaxHighlighter>
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code3}</SyntaxHighlighter>
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code4}</SyntaxHighlighter>
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code5}</SyntaxHighlighter>
							<p>I typically use JPA's <b>@Procedure</b> for simple cases with IN/OUT parameters. For more complex scenarios, I use <b>EntityManager</b> with <b>StoredProcedureQuery</b> to have full control over parameter binding and result handling.</p>
							<p><b>Difference b/w functions and procedures</b></p>
							<div style={{ backgroundColor: "#f4f6f8", padding: "20px" }}>
								<div style={captionStyle}>Procedure vs Function</div>
								<table style={tableStyle}>
									<thead>
										<tr>
											<th style={thStyle}>Feature</th>
											<th style={thStyle}>Procedure</th>
											<th style={thStyle}>Function</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td style={tdStyle}>Return value</td>
											<td style={tdStyle}>Not required</td>
											<td style={tdStyle}>
												<strong>Mandatory (uses RETURN)</strong>
											</td>
										</tr>
										<tr style={rowAltStyle}>
											<td style={tdStyle}>How it returns data</td>
											<td style={tdStyle}>Uses OUT parameters</td>
											<td style={tdStyle}>Uses RETURN keyword</td>
										</tr>
										<tr>
											<td style={tdStyle}>Usage in SQL</td>
											<td style={tdStyle}>Cannot be used in SELECT</td>
											<td style={tdStyle}>Can be used in SELECT</td>
										</tr>
										<tr style={rowAltStyle}>
											<td style={tdStyle}>Purpose</td>
											<td style={tdStyle}>Business logic / operations</td>
											<td style={tdStyle}>Computation / value calculation</td>
										</tr>
										<tr>
											<td style={tdStyle}>Calling style</td>
											<td style={tdStyle}>
												<code>CALL procedure_name(...)</code>
											</td>
											<td style={tdStyle}>
												<code>SELECT function_name(...)</code>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code6}</SyntaxHighlighter>
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code7}</SyntaxHighlighter>

						</CAccordionBody>
				</CAccordionItem>		
				<CAccordionItem itemKey={3}>
						<CAccordionHeader>SQL Query</CAccordionHeader>
						<CAccordionBody> 
							<p><b>Customer</b></p>
							<div
								style={{
									display: 'inline-block',
									border: '1px solid #ccc',
									fontFamily: 'Arial, sans-serif',
									fontSize: '14px'
								}}
							>
								{/* Header */}
								<div style={{ display: 'flex', backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
									<div style={{ padding: '8px 16px', borderRight: '1px solid #ccc', width: '60px' }}>id</div>
									<div style={{ padding: '8px 16px', width: '120px' }}>name</div>
								</div>

								{/* Row 1 */}
								<div style={{ display: 'flex', borderTop: '1px solid #ccc' }}>
									<div style={{ padding: '8px 16px', borderRight: '1px solid #ccc', width: '60px' }}>1</div>
									<div style={{ padding: '8px 16px', width: '120px' }}>John</div>
								</div>

								{/* Row 2 */}
								<div style={{ display: 'flex', borderTop: '1px solid #ccc' }}>
									<div style={{ padding: '8px 16px', borderRight: '1px solid #ccc', width: '60px' }}>2</div>
									<div style={{ padding: '8px 16px', width: '120px' }}>Alice</div>
								</div>

								{/* Row 3 */}
								<div style={{ display: 'flex', borderTop: '1px solid #ccc' }}>
									<div style={{ padding: '8px 16px', borderRight: '1px solid #ccc', width: '60px' }}>3</div>
									<div style={{ padding: '8px 16px', width: '120px' }}>Bob</div>
								</div>
							</div>
							<p></p>
							<p><b>orders</b></p>

							<div
								style={{
									display: 'inline-block',
									border: '1px solid #ccc',
									fontFamily: 'Arial',
									fontSize: '14px'
								}}
							>
								{/* Header */}
								<div style={{ display: 'flex', backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
									<div style={{ padding: '8px', width: '60px', borderRight: '1px solid #ccc' }}>id</div>
									<div style={{ padding: '8px', width: '120px', borderRight: '1px solid #ccc' }}>customer_id</div>
									<div style={{ padding: '8px', width: '100px' }}>amount</div>
								</div>

								{/* Rows */}
								{data.map((row) => (
									<div key={row.id} style={{ display: 'flex', borderTop: '1px solid #ccc' }}>
										<div style={{ padding: '8px', width: '60px', borderRight: '1px solid #ccc' }}>
											{row.id}
										</div>
										<div style={{ padding: '8px', width: '120px', borderRight: '1px solid #ccc' }}>
											{row.customer_id}
										</div>
										<div style={{ padding: '8px', width: '100px' }}>
											{row.amount}
										</div>
									</div>
								))}
							</div>
							<p></p>
							<p><b>1. INNER JOIN</b></p>
							<p>Returns only matching records from both tables.</p>
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code8}</SyntaxHighlighter>
							<div
								style={{
									display: 'inline-block',
									border: '1px solid #ccc',
									fontFamily: 'Arial',
									fontSize: '14px'
								}}
							>
								{/* Header */}
								<div style={{ display: 'flex', backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
									<div style={{ padding: '8px', width: '120px', borderRight: '1px solid #ccc' }}>name</div>
									<div style={{ padding: '8px', width: '100px' }}>amount</div>
								</div>

								{/* Rows */}
								{data2.map((row, index) => (
									<div key={index} style={{ display: 'flex', borderTop: '1px solid #ccc' }}>
										<div style={{ padding: '8px', width: '120px', borderRight: '1px solid #ccc' }}>
											{row.name}
										</div>
										<div style={{ padding: '8px', width: '100px' }}>
											{row.amount}
										</div>
									</div>
								))}
							</div>
							<p></p>
							<p><b>2. LEFT JOIN</b></p>
							<p>Returns ALL records from left table + matching from right table</p>
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code9}</SyntaxHighlighter>
							<div
								style={{
									display: 'inline-block',
									border: '1px solid #ccc',
									fontFamily: 'Arial',
									fontSize: '14px'
								}}
							>
								{/* Header */}
								<div style={{ display: 'flex', backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
									<div style={{ padding: '8px', width: '120px', borderRight: '1px solid #ccc' }}>name</div>
									<div style={{ padding: '8px', width: '100px' }}>amount</div>
								</div>

								{/* Rows */}
								{data3.map((row, index) => (
									<div key={index} style={{ display: 'flex', borderTop: '1px solid #ccc' }}>
										<div style={{ padding: '8px', width: '120px', borderRight: '1px solid #ccc' }}>
											{row.name}
										</div>
										<div style={{ padding: '8px', width: '100px' }}>
											{row.amount !== null ? row.amount : 'NULL'}
										</div>
									</div>
								))}
							</div>
							<p></p>
							<p><b>3. RIGHT JOIN</b></p>
							<p>Returns ALL records from right table + matching from left table</p>
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code10}</SyntaxHighlighter>		
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									width: "300px",
									border: "1px solid #ccc",
									fontFamily: "Arial, sans-serif",
								}}
							>
								{/* Header */}
								<div style={{ display: "flex", backgroundColor: "#f5f5f5", fontWeight: "bold" }}>
									<div style={{ flex: 1, padding: "8px", borderBottom: "1px solid #ddd", borderRight: "1px solid #ddd" }}>
										name
									</div>
									<div style={{ flex: 1, padding: "8px", borderBottom: "1px solid #ddd" }}>
										amount
									</div>
								</div>

								{/* Rows */}
								{data4.map((item, index) => (
									<div key={index} style={{ display: "flex" }}>
										<div style={{ flex: 1, padding: "8px", borderBottom: "1px solid #ddd", borderRight: "1px solid #ddd" }}>
											{item.name}
										</div>
										<div style={{ flex: 1, padding: "8px", borderBottom: "1px solid #ddd" }}>
											{item.amount}
										</div>
									</div>
								))}
							</div>
							<p></p>
							<p><b>4. FULL OUTER JOIN</b></p>
							<p>Returns everything from both tables</p>
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code11}</SyntaxHighlighter>		

							<p></p>
							<p><b>5. UNION</b></p>
							<p>Combines results from two SELECT queries. Removes duplicates automatically</p>
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code12}</SyntaxHighlighter>
							<p></p>
							<p><b>6. UNION ALL</b></p>
							<p>Combines results from two SELECT queries. Keeps duplicates</p>

							<p></p>
							<p><b>6. GROUP BY</b></p>
							<p>Used to aggregate data (SUM, COUNT, AVG, etc.)</p>
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code13}</SyntaxHighlighter>

							<p></p>
							<p><b>7. HAVING</b></p>
							<p>Used to filter aggregated data (SUM, COUNT, AVG, etc.)</p>
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code14}</SyntaxHighlighter>					
						</CAccordionBody>
				</CAccordionItem>																		
				</CAccordion>
			</CCardBody>
    </CCard>        
  )
}

export default CockroachDB;